<template>
  <div class="video-box">
    <!-- <popUp v-if="popUpToggle" v-on:doClose="close" :size="'middle'">
      <div class="pop-title" slot="title">
        <h2 style="font-weight: bold;">看更多</h2>
      </div>
      <div slot="info" class="info-main" >
        <ul class="list-group list-group-flush">
          <li v-for="(item, index) in lessonList"  @click="goCoursePage(item.id)" :key="index" class="list-group-item list-group-item-action d-flex align-items-center justify-content-between pointer" :class="{'current' : item.id == lessonId}">
            <span>
              <div style="font-size: 1.5rem;">
                {{ item.name }}
              </div>
              <div v-if="item.name_en" style="font-size: .8rem;" v-html="forceToJap(item.name_en)"></div>
            </span>
            <div>
              <img class="my-auto mx-1" v-if="item.is_read" style="width:25px; height:25px" src="@/assets/image/icon&btn/icon_other/icon_read_G.png" alt="">
              <img class="my-auto mx-1" v-if="item.is_pass" style="width:25px; height:25px" src="@/assets/image/pic/icon_class_video_complete.png" alt="">
            </div>
          </li>
        </ul>
      </div>
    </popUp> -->

    <div class="d-flex w-100">
      <div class="navbar_l pointer" @click.self="navbarToggle" :class="{'active_l': !toggle }">
        <ul class="list-group p-0">
          <li class="list-group-item list-group-item-action m-0 px-0 pointer text-black" :class="{ 'current' : $route.name === 'ai_course' }">
            <router-link :to="{ 'name': 'ai_course', params: { lesson: $route.params.lesson, courseId: promptId} }" class="d-block">
              <img class="icon" src="@/assets/image/icon&btn/icon_have_btn_function/btn_sideFunction_chat.png" alt=""><br>
              <span>AI 口說挑戰</span>
            </router-link>
          </li>
          <!-- <li class="list-group-item list-group-item-action m-0 px-0 pointer">
            <router-link :to="{ 'name': 'CourseLesson', params: { lesson: $route.params.lesson, courseId: course_id} }" class="d-block" v-if="course_id">
              <img class="icon" src="@/assets/image/icon&btn/icon_have_btn_function/btn_sideFunction_home.png" alt=""><br><span>返回</span>
            </router-link>
          </li> -->
          <!-- <li @click="$router.back()" class="list-group-item list-group-item-action m-0 px-0 pointer"><img class="icon" src="../assets/image/icon&btn/icon_have_btn_function/btn_sideFunction_home.png" alt=""><br><span>返回</span></li> -->
        </ul>
        <div class="collapse-icon" :class="{'rotate':!toggle}">
          <font-awesome-icon @click.self="navbarToggle" class="pointer chevron" size="lg" :icon="['fa', 'chevron-right']" style="color:rgba(0, 0, 0, .2)"/>
        </div>
      </div>
      <div class="flex-1 contain-main">
        <div class="py-3 px-2 text-left ">
          <div class="main-content mx-auto">
            <header class="" v-if="lesson">
              <h3 class="font-weight-bold">{{ lesson.name }}</h3>
              <p class="text-muted mb-0" v-html="forceToJap(lesson.name_en)"></p>
            </header>
          </div>
        </div>
        <router-view class="flex-1"></router-view>
      </div>

      <!-- <div v-if="currentData" class="video mx-auto" style="width:100%;max-width: 1280px!important;min-width: 320px!important;min-height:980px" >
        <div class="m-3" style="text-align:left" >
          <img class="pointer" style="float:right;width:40px" v-if="favorite" @click="removeCollections(lessonId)" src="@/assets/image/pic/btn_function_mark_on.png" alt="">
          <img class="pointer" style="float:right;width:40px" v-else @click="addCollections(lessonId)" src="@/assets/image/pic/btn_function_mark_off.png" alt="">
          <img class="pointer rwd-more" style="float:right;width:40px;padding:5px" @click="getLessonList" src="@/assets/image/icon&btn/icon_have_btn_function/btn_more.png" alt="">

          <h3>{{ titleName.name }}</h3>
          <h6 v-html="forceToJap(titleName.name_en)"></h6>

          <div class="btn-group mt-2 rwd-list" role="group">
            <button v-for="(item, index) in videoData" :key="'rwd-'+index" type="button" class="btn btn-outline-secondary" :class="{'active' : current === index}" @click="goLesson(index)">
              {{ item.type === 'video' ? '名師講解' : (item.type === 'live_course' ? '互動課程' : '挑戰測驗') }}
            </button>
            <button type="button" class="btn btn-outline-secondary" :class="{'active' : current === 'ai'}" @click="goLesson('ai')">
              AI 口說挑戰
            </button>
          </div>
        </div>

        <div class="content-wrapper w-100">
          <div>
            <div v-if="lesson && (currentData.type === 'live_course' || currentData.type === 'practice')">
              <live-player :moduleEnable="['video', 'detail' ,'article', 'ebook', 'text', 'practice' , 'reading' ,'vocabulary']" v-on:updatedVideoState="updatedVideoState" :liveData="lesson" :articleImg="cover" :sectionId="sectionId" />
            </div>

            <player v-if="currentData.type === 'video'" style="width:100%; background:black; height:50vh" class="m-auto" v-on:updatedVideoState="updatedVideoState" :url="currentData.data.path"/>

            <practice :key="sectionId" :sectionId="sectionId" style="width:85%" v-if="currentData.type === 'practice'" class="page mx-auto py-5" :setNoticePage="true" :quests="JSON.parse(currentData.data.questions).practices" v-on:score="handlerPracticeScore" :passRate="config.practice ? config.practice.passRate : -1">
            </practice>
          </div>

        </div>
      </div>
      <div v-if="current === 'ai'" class="bg-light w-100">
        <ai_course class="mx-auto" style="width:100%;max-width: 1280px!important;min-width: 320px!important;min-height:980px" />
      </div> -->
    </div>
  </div>
</template>

<script>
import api from '@/store/api'
export default {
  name: 'CourseLayout',
  components: {
  },
  props: {
    config: {
      type: Object,
      required: false,
      default: () => {
        return {
          practice: {
            noticePage: false,
            passRate: -1
          }
        }
      }
    },
    idleTime: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      toggle: true,
      lesson: null,
      courseId: null
    }
  },
  computed: {
    lessonId () {
      return this.$route.params.lesson
    },
    promptId () {
      if (this.$route.name === 'course_chat') {
        return this.$route.params.promptId
      }
      return this.$route.params.courseId
    },
    course_id () {
      if (this.lesson) {
        return this.lesson.sections.find(item => item.type === 'live_course').data.view_id || null
      }
      return ''
    }
  },
  watch: {
  },
  async beforeDestroy () {
  },
  async mounted () {
this.getLessonId(this.lessonId)
  },
  methods: {
    navbarToggle () {
      this.toggle = !this.toggle
    },
    forceToJap (sent, hidePinyin = false) {
      if (!sent) return
      const split = sent.split(/{(.+?)}/)
      let newSent = ''
      for (const i in split) {
        if (split[i].indexOf('=') > -1) {
          if (!hidePinyin) {
            newSent += '<ruby>' + split[i].split(/=/)[0] + '<rt>' + split[i].split(/=/)[1] + '</rt></ruby>'
          } else {
            newSent += split[i].split(/=/)[0]
          }
        } else {
          newSent += split[i]
        }
      }
      return newSent
    },
    async getLesson (id) {
      const { data } = await api.get(`/contents/lesson/${id}`)
      this.lesson = data.data
    },
    async getLessonId (id) {
      const { data } = await api.get(`/contents/courses/${id}`)
      if (data.status === 'Success') {
        this.lesson = data.data
        this.favorite = data.data.is_favorite
        this.parentId = data.data.package_course.id
        this.cover = data.data.cover
        return data.data
      }
    }
    // goPage () {
    //   this.$router.push({ name: 'Course', params: { channel: this.parentId } })
    // },
  }
}
</script>

<style scoped lang="scss">
  .main-content {
    max-width: 1280px;
  }
  .contain-main {
    background: #eaedf2;
  }
  .video-box {
    min-height: calc(100vh - 113px) !important;
  }
  .navbar_l {
    position: relative;
    min-height: calc(100vh - 113px)  !important;
    border: 1px solid rgb(207, 205, 205);
    ul {
      text-align: center;
      padding: 10px;
      white-space:nowrap;
      list-style-type: none;
      overflow: hidden;
      li {
        font-weight: 800;
        margin: 10px 0;
      }
    }
    width: 150px;
    background-color: rgb(255, 255, 255) !important;
    transition: all .5s cubic-bezier(0.25,0.1,0.25,1);
    opacity: 1;
  }
  .active_l {
    width: 65px;
    span {
      opacity: 0;
    }
  }
  .icon {
    width: 35px;
  }
  .hide {
    display: none;
  }
  .rwd-list {
    display: none;
  }
  .collapse-icon {
    position: absolute;
    transition: all .5s cubic-bezier(0.25,0.1,0.25,1);
    top:50%;
    right: 5%;
    transform: translate(-50%, -50%);
    transform: rotate(900deg);
  }
  .rotate {
    transform: rotate(0deg);
  }
  .current  {
    background-color: rgb(238, 238, 238) !important;
  }
  .rwd-more {
    display: none;
  }
  @media (max-width: 480px) {
    .navbar_l {
      display: none;
    }
    .rwd-list {
      button:active,button:focus {
        outline: none !important;
        box-shadow: none !important;
      }
      display: flex;
    }
  }
  @media (max-width: 480px) {
    .rwd-more {
      display: block;
    }
  }
  a {
    color: #495057 !important;
    &:hover {
      text-decoration: none !important;
    }
  }
</style>